import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { queryClient } from '../providers/QueryProvider';
import { apiClient } from '../api/client';

interface User {
    id: string;
    name: string;
    email?: string;
    employeeId: number;
    role: 'SUPER_ADMIN' | 'BRANCH_MANAGER' | 'CASHIER' | 'WAITER' | 'RECEPTIONIST' | 'DATA_AUDITOR';
    branchId?: string;
    branchName?: string;
    assignedSection?: 'INDIVIDUAL' | 'FAMILY' | null;
}

interface AuthState {
    user: User | null;
    isAuthenticated: boolean;
    _hasHydrated: boolean;
    setAuth: (user: User) => void;
    logout: () => Promise<void>;
    updateUser: (user: Partial<User>) => void;
    setHasHydrated: (state: boolean) => void;
}

export const useAuthStore = create<AuthState>()(
    persist(
        (set, get) => ({
            user: null,
            isAuthenticated: false,
            _hasHydrated: false,

            setAuth: (user) => {
                set({ user, isAuthenticated: true });
            },

            logout: async () => {
                if (get().isAuthenticated) {
                    try {
                        await apiClient.post('/auth/logout');
                    } catch (e) {
                        // Silently ignore logout errors on client
                    }
                }
                queryClient.clear();
                set({ user: null, isAuthenticated: false });
            },

            updateUser: (updatedUser) => {
                set((state) => ({
                    user: state.user ? { ...state.user, ...updatedUser } : null,
                }));
            },

            setHasHydrated: (state) => {
                set({ _hasHydrated: state });
            },
        }),
        {
            name: 'india-place-auth',
            partialize: (state) => ({
                user: state.user,
                isAuthenticated: state.isAuthenticated,
            }),
            onRehydrateStorage: () => (state) => {
                state?.setHasHydrated(true);
            },
        }
    )
);
